import { render, staticRenderFns } from "./sub-form-item.vue?vue&type=template&id=be529042&scoped=true"
import script from "./sub-form-item.vue?vue&type=script&lang=js"
export * from "./sub-form-item.vue?vue&type=script&lang=js"
import style0 from "./sub-form-item.vue?vue&type=style&index=0&id=be529042&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be529042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be529042')) {
      api.createRecord('be529042', component.options)
    } else {
      api.reload('be529042', component.options)
    }
    module.hot.accept("./sub-form-item.vue?vue&type=template&id=be529042&scoped=true", function () {
      api.rerender('be529042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-render/container-item/sub-form-item.vue"
export default component.exports